import React, { useState } from "react";
import { Card, Typography, Button, Grid, Box } from "@mui/material";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { useNavigate } from "react-router-dom";

const SelectionSummaryReportStartingPage = () => {
  const navigate = useNavigate();
  const [selectedReport, setSelectedReport] = useState(null);

  return (
    <Grid
      container
      sx={{ height: "100vh", justifyContent: "center", alignItems: "center" }}
    >
      <Card
        sx={{
          width: "893px",
          height: "361px",
          padding: 3,
          textAlign: "center",
          boxShadow: 1,
        }}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ marginBottom: 1 }}>
          Select type of test report
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ opacity: 0.6, marginBottom: 3 }}
        >
          Please select type of report you want to generate from below and
          continue.
        </Typography>

        <Grid container spacing={2} justifyContent="center">
          {["Release Summary Report", "Sprint Summary Report"].map(
            (report, index) => {
              const isSelected = selectedReport === report;
              return (
                <Grid item key={index}>
                  <Card
                    variant="outlined"
                    onClick={() => setSelectedReport(report)}
                    sx={{
                      width: "350px",
                      height: "180px",
                      padding: 2,
                      textAlign: "center",
                      borderColor: isSelected ? "#1976d2" : "grey",
                      cursor: "pointer",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box>
                      <Typography fontWeight="bold">{report}</Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ marginY: 1, minHeight: "48px" }}
                      >
                        {report === "Release Summary Report"
                          ? "A test summary report provides a comprehensive overview of the testing activities conducted during a specific period."
                          : "The Sprint Summary Report provides a concise overview of the work completed during a sprint."}
                      </Typography>
                    </Box>
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{
                        backgroundColor: isSelected ? "#1976d2" : "grey",
                        color: "white",
                        cursor: "pointer",
                      }}
                      startIcon={<GenerateButton />}
                      onClick={() =>
                        navigate(
                          selectedReport === "Sprint Summary Report"
                            ? "/dashboard/sprint-summary-report/output"
                            : ""
                        )
                      }
                    >
                      Continue
                    </Button>
                  </Card>
                </Grid>
              );
            }
          )}
        </Grid>
      </Card>
    </Grid>
  );
};

export default SelectionSummaryReportStartingPage;
